import { BEATBLOX_PATH } from './constants/paths';

export default {
  read: (code) => `${BEATBLOX_PATH}/${code}`,
};
